module.exports = __webpack_public_path__ + "img/02.6057426b.jpg";